const OldMetaDataList = () => import('Views/metaData/metaData-list-new-ui');
const MetaDataList = () => import('Views/metaData/metaData-es-list-new-ui');
const MetaDataDetail = () => import('Views/metaData/metaData-detail-new-ui');
const ChosenMetaDataList = () => import('Views/metaData/chosen-metaData-list');
const Contact = () => import('Views/home/contact');


export default[
  { path: '/old-metaData-list', component: OldMetaDataList },
  { path: '/metaData-list', component: MetaDataList },
  { path: '/metaData-detail/:id', component: MetaDataDetail },
  { path: '/chosen-metaData-list', component: ChosenMetaDataList },
  { path: '/contact', component: Contact },
];



// WEBPACK FOOTER //
// ./src/router/metaData.js